export default __webpack_public_path__ + "static/media/shipetiari3.4172eaa7.jpg";